import { Tabs } from '../../model';

interface IRenderConditions {
  shouldRenderDescriptionTab: boolean;
}

export const getDefaultTab = ({
  shouldRenderDescriptionTab,
}: IRenderConditions) => {
  if (shouldRenderDescriptionTab) {
    return Tabs.Description;
  }

  return Tabs.AboutBrand;
};
